<template>
  <score-main @back="goBack">
    <template slot="nav">
      <div class="scoreNav">
        <p>教练员成绩详情</p>
      </div>
    </template>
    <template slot="main">
      <div class="scoreMain">
        <div class="scrollArea">
          <template v-if="showInfo">
            <vue-scroll :ops="ops">
              <div class="enquiriesResult">
                <div class="content">
                  <div class="stuInfo">
                    <div class="left">
                      <div class="tr">
                        <div class="td info_left">姓名（中文）：{{rankData.coachUser.coachName || "--"}}</div>
                        <div class="td" v-if="rankData.coachUser.coachNameFamilyEn">姓名（拼音）：{{rankData.coachUser.coachNameFamilyEn}} {{rankData.coachUser.coachNameGivenEn}}</div>
                        <div class="td" v-else>姓名（拼音）：--</div>
                      </div>
                      <div class="tr">
                        <div class="td info_left">性别：{{rankData.coachUser.coachSex || "--"}}</div>
                        <div class="td">国籍：{{rankData.coachUser.nationality || "--"}}</div>
                      </div>
                      <div class="tr">
                        <div class="td info_left">出生日期：{{rankData.coachUser.coachBirthday || "--"}}</div>
                        <div class="td" v-if="rankData.coachUser.coachBirthday">年龄：{{  getAge(rankData.coachUser.coachBirthday) }}岁</div>
                        <div class="td" v-else>年龄：--</div>
                      </div>
                      <div class="tr">
                        <div class="td info_left">证件类型：{{rankData.coachUser.idNumber ? "中国居民身份证 " : "护照"}}</div>
                        <div class="td">证件号：{{rankData.coachUser.idNumber || rankData.coachUser.idPassport}}</div>
                      </div>
                      <div class="tr">
                        <div class="td info_left" >教练员等级：{{rankData.coachUser.coachRankType | level}} </div>
                        <div class="td">
                          守门员教练员等级：{{rankData.coachUser.coachRankSpecialType | level}}
                        </div>
                      </div>
                      <div class="tr">
                        <div class="td info_left">
                          体能教练员等级：{{rankData.coachUser.coachRankPhysicalType | level}}
                        </div>
                        <div class="td">注册足协：{{rankData.coachUser.organ_mark || '--'}}</div>
                      </div>
                    </div>
                    <div class="right">
                      <img :src="!rankData.coachUser.profilePicture?userImg:rankData.coachUser.profilePicture"
                           @error="imgError"
                           alt="">
                    </div>
                  </div>
                  <!-- 等级教练员执照 -->
                  <template v-if="rankData.coachUser.coachLicenseNumber && rankData.coachUser.coachRankType && rankData.coachUser.coachLicenseEnd && !isFive">
                    <div class="rankInfoData" >
                      <div class="title">
                        <v-icon class="logo"
                                name="regular/file-alt"
                                scale="1.8"></v-icon>
                        <p>等级教练员执照</p>
                      </div>
                    </div>
                    <div class="rankInfo LicenseInfo">
                      <el-row class="score-row">
                        <el-col :span="7"
                                class="score-col">
                          <p >等级：{{rankData.coachUser.coachRankType | level}}</p>
                        </el-col>
                        <el-col :span="9"
                                class="score-col">
                          <p>执照编号：{{rankData.coachUser.coachLicenseNumber||'--'}}</p>
                        </el-col>
                        <el-col :span="8"
                                class="score-col">
                          <p>有效期至：{{rankData.coachUser.coachLicenseEnd ||'--'}}</p>
                        </el-col>
                      </el-row>
                    </div>
                  </template>
                  <!-- 守门员教练级别 -->
                  <template v-if="rankData.coachUser.coachLicenseNumber && rankData.coachUser.coachRankSpecialType && !isFive" >
                    <div class="rankInfoData" >
                      <div class="title">
                        <v-icon class="logo"
                                name="regular/file-alt"
                                scale="1.8"></v-icon>
                        <p>守门员教练员执照</p>
                      </div>
                    </div>
                    <div class="rankInfo LicenseInfo">
                      <el-row class="score-row">
                        <el-col :span="7"
                                class="score-col">
                          <p >等级：{{rankData.coachUser.coachRankSpecialType | level}}</p>
                        </el-col>
                        <el-col :span="9"
                                class="score-col">
                          <p>执照编号：{{rankData.coachUser.coachLicenseNumber||'--'}}</p>
                        </el-col>
                        <el-col :span="8"
                                class="score-col">
                          <p >有效期至：{{rankData.coachUser.coachGoalieLicenseEnd ||'--'}}</p>
                        </el-col>
                      </el-row>
                    </div>
                  </template>
                  <!-- 体能教练级别 -->
                  <template v-if="rankData.coachUser.coachRankPhysicalType && ['F1', 'F2'].includes(rankData.coachUser.coachRankPhysicalType) && rankData.coachUser.coachPhysicalLicenseEnd &&
                      rankData.coachUser.coachLicenseNumber && !isFive">
                    <div class="rankInfoData" >
                      <div class="title">
                        <v-icon class="logo"
                          name="regular/file-alt"
                          scale="1.8"></v-icon>
                        <p>体能教练员执照</p>
                      </div>
                    </div>
                    <div class="rankInfo LicenseInfo">
                      <el-row class="score-row">
                        <el-col :span="7"
                          class="score-col">
                          <p >等级：{{rankData.coachUser.coachRankPhysicalType | level}}</p>
                        </el-col>
                        <el-col :span="9"
                          class="score-col">
                          <p>执照编号：{{rankData.coachUser.coachLicenseNumber||'--'}}</p>
                        </el-col>
                        <el-col :span="8"
                          class="score-col">
                          <p >有效期至：{{rankData.coachUser.coachPhysicalLicenseEnd ||'--'}}</p>
                        </el-col>
                      </el-row>
                    </div>
                  </template>
                  <div class="rankInfoData">
                    <div class="title">
                      <v-icon class="logo"
                              name="regular/file-alt"
                              scale="1.8"></v-icon>
                      <p>教练员培训历程</p>
                    </div>
                  </div>
                  <div class="rankInfo" v-for="(item, index) in rankData.ranks" :key="index">
                    <el-row class="score-row">
                      <el-col :span="12"
                        class="score-col">
                        <p>等级：{{item | coachHistoryFilter}}</p>
                      </el-col>
                      <el-col :span="12"
                        class="score-col">
                        <p>通过状态：{{item.coachRankStatus=='有效'?'通过':item.coachRankStatus}}<span v-if="item.coachRankTypeStatus">({{item.coachRankTypeStatus}})</span></p>
                      </el-col>
                    </el-row>
                    <el-row class="score-row">
                      <el-col :span="12"
                        class="score-col">
                        <p>所属年份：{{item.coachRankYear}}年</p>
                      </el-col>
                      <el-col :span="12"
                        class="score-col">
                        <p>讲师：{{item.lecturerName || "--"}}</p>
                      </el-col>
                    </el-row>
                    <el-row class="score-row">
                      <el-col :span="12"
                        class="score-col">
                        <p>举办方：{{item.coachRankOrgan || "--"}}</p>
                      </el-col>
                      <el-col :span="12"
                        class="score-col">
                        <p>培训地点：{{item.classAddress || "--"}}</p>
                      </el-col>
                    </el-row>
                    <el-row class="score-row">
                      <el-col :span="12"
                        class="score-col">
                        <p>培训开始时间：{{item.classStart || "--"}}</p>
                      </el-col>
                      <el-col :span="12"
                        class="score-col">
                        <p>培训结束时间：{{item.classEnd || "--"}}</p>
                      </el-col>
                    </el-row>
                    <el-row class="score-row" v-if="item.coachRankStatus=='有效'">
                      <el-col :span="12"
                              class="score-col">
                        <p>证书编号：{{item.certificateNum || "--"}}<span v-if="item.certificateUrl " style="cursor:pointer;color: #4cd964" ><a
                             target="_blank"   :href="item.certificateUrl">（查看电子证书）</a></span></p>
                      </el-col>
                      <el-col :span="12"
                              class="score-col">
                        <p>编号时间：{{item.certificateDate || "--"}}</p>
                      </el-col>
                    </el-row>
<!--                    <el-row class="score-row" v-if="item.certificateUrl && (item.coachRankType ==='C' || item.coachRankType ==='D')">-->
<!--                      <el-col :span="24" class="score-col">-->
<!--                        <p>执教执照正在生成中，电子证书暂时被锁定，执教执照生成后会自动恢复下载。</p>-->
<!--                      </el-col>-->
<!--                    </el-row>-->
                    <el-row class="score-row" v-if="item.score">
                      <div class="score-table" >
                        <div class="row">
                          <div class="score-col"
                               v-for="(item_score, s) in item.score" :key="s">
                            <p>{{ item_score.achievementSubjectTitle  }}</p>
                            <p >{{item_score.achievementScore}}
                              <span v-if="Number(item_score.achievementScore)">分</span>
                            </p>
                          </div>
                        </div>
                      </div>
                    </el-row>
                    <el-row class="score-row bz" v-if="!!item.achievementRemark">
                        <el-col :span="24"
                              class="score-col">
                        <p>备注：{{item.achievementRemark}}</p>
                      </el-col>
                    </el-row>
                    <template v-if="item.createCoachRank===3">
                      <el-row class="score-row bz" v-if="item.coachRankStatus==='有效'">
                        <el-col :span="24" class="score-col">
                          <p>2008年12月31日之前参加岗位培训的足球教练员不颁发电子证书，无需提交缺失资质审核。详细内容请参见<span style="color: #4cd964"><a
                                  href="http://www.thecfa.cn/hitz/20190909/27995.html" target="_blank">《中国足协关于发放亚足联/中国足协教练员等级证书和执照的通知》</a></span> </p>
                        </el-col>
                      </el-row>
                    </template>
                    <template v-else-if="item.createCoachRank===4">
                      <el-row class="score-row bz" v-if="item.coachRankStatus==='有效'">
                        <el-col :span="24" class="score-col">
                          <p>教练员在国外获得的教练员等级证书或在国内参加国外驻华或来华机构举办的教练员培训班获得的等级证书，通过中国足协认证后仅颁发新的执教执照，不再颁发新的电子证书。</p>
                        </el-col>
                      </el-row>
                    </template>
                    <template v-else>
                      <el-row class="score-row bz" v-if=" item.coachRankStatus==='有效' && (item.coachRankPhysicalType === 'F1' || item.coachRankPhysicalType === 'F2') && Number(item.coachRankYear) < 2022">
                        <el-col :span="24"
                          class="score-col">
                          <p>2021年12月31日之前参加培训的体能L1级/体能L2级教练员不颁发电子证书，无需提交缺失资质审核。详细内容请参见<span style="color: #4cd964"><a
                            href="http://www.thecfa.cn/hitz/20190909/27995.html" target="_blank">《中国足协关于发放亚足联/中国足协教练员等级证书和执照的通知》</a></span> </p>
                        </el-col>
                      </el-row>
                      <el-row class="score-row bz" v-if=" item.coachRankStatus==='有效' && item.coachRankType==='D' && Number(item.coachRankYear) < 2019">
                        <el-col :span="24"
                                class="score-col">
                          <p>2018年12月31日之前参加培训的D级教练员不颁发电子证书，无需提交缺失资质审核。详细内容请参见<span style="color: #4cd964"><a
                                  href="http://www.thecfa.cn/hitz/20190909/27995.html" target="_blank">《中国足协关于发放亚足联/中国足协教练员等级证书和执照的通知》</a></span> </p>
                        </el-col>
                      </el-row>
                      <el-row
                        class="score-row bz"
                        v-else-if="
                                  item.coachRankStatus === '有效' &&
                                  item.coachRankType === 'early' &&
                                  Number(item.coachRankYear) < 2019
                                "
                      >
                        <el-col :span="24" class="score-col">
                          <p>2018年12月31日之前参加培训的五人制足球初级教练员不颁发电子证书，无需提交缺失资质审核。</p>
                        </el-col>
                      </el-row>
                      <el-row
                          class="score-row bz"
                          v-else-if="
                                  item.coachRankStatus === '有效' &&
                                  item.coachRankType === 'L1' &&
                                  item.classTheQuality === 'futsal'
                                "
                      >
                        <el-col :span="24" class="score-col">
                          <p>五人制足球L1级教练员暂时不颁发电子证书，无需提交缺失资质审核。</p>
                        </el-col>
                      </el-row>
                      <el-row class="score-row bz" v-else-if="item.certificateNum && !item.certificateUrl && !item.coachRankPhysicalType" >
                        <el-col :span="24"
                                class="score-col">
                          <p>电子证书正在制作中，请通过教练员培训管理系统查看个人执教资质。若急需证明文件，请联系注册协会，带来不便敬请谅解。</p>
                        </el-col>
                      </el-row>
                    </template>
                    <div v-if="index !== rankData.ranks.length - 1" class="dashed-line"></div>
                  </div>
                </div>
              </div>
            </vue-scroll>
          </template>
          <template v-if="showEmpty">
            <yioks-empty></yioks-empty>
          </template>
        </div>
      </div>
    </template>
  </score-main>
</template>

<script>
  import userImg from "@/assets/images/person.png";
  import ops from '@/assets/js/vuescrollOption';
  import "vue-awesome/icons/regular/file-alt";
  import {LevelFilters} from "@/assets/js/status";
  import { coachHistoryFilter } from "@/assets/js/yioksFilters";
  import {coachScore} from "@/api/system_manager/api";
  import fiveMixins from '@/minix/fiveMixins';
  let {keys} = Object;

  export default {
    name: "coach-score",
    mixins: [fiveMixins],
    data() {
      return {
        userImg,
        ops: ops(),
        uid: this.$route.query.id,
        showInfo: false,
        showEmpty: false,
        rankData: {
          coachUser: {},
          ranks: [],
          certificates: [],
          achievemens: [],
          rankList: [],
          license:{},
        },
      };
    },
    components: {
      "score-main": () => import("@/components/LayOut/Common/up-down"),
      "v-icon": () => import("vue-awesome/components/Icon"),
      "yioks-empty": () => import("@/components/Tips/Empty"),
    },
    created() {
      this.request();
    },
    methods: {
      goBack() {
        this.$router.go(-1);
      },
      imgError() {
        this.$set(this.rankData.coachUser, "profilePicture", this.userImg);
      },
      request() {
        coachScore({coachUid: this.uid})
          .then(({data})=>{
            const achievement = data.result.infoData;
            if (!keys(achievement).length) {
              this.showEmpty = true;
              return false;
            }
            console.log('achievement', achievement)
            const {coachUser, ranks, certificates,achievemens,score,license} = achievement;
            if (coachUser) this.rankData.coachUser = coachUser; // 获取用户信息
            if (license) this.rankData.license=license;
            if (ranks) this.rankData.ranks = ranks.sort((pre, next) => {
              return next.coachRankYear - pre.coachRankYear;
            }); // 获取等级
            if (certificates) this.rankData.certificates = certificates; //获取证书
            if (achievemens) this.rankData.achievemens = achievemens; //获取成绩信息
            // 处理证书
            let certificateInfo = {};
            if (certificates.length > 0) {
              for (let i = 0; i < certificates.length; i++) {
                const {rankId} = certificates[i];
                certificateInfo[rankId] = certificates[i];
              }
            }

            // 处理证书
            let achievemensInfo = {};
            if (achievemens.length > 0) {
              for (let i = 0; i < achievemens.length; i++) {
                const {rankId} = achievemens[i];
                achievemensInfo[rankId] = achievemens[i];
              }
            };

            // 遍历等级
            if (ranks.length > 0) {
              for (let j = 0; j < ranks.length; j++) {
                const {id} = ranks[j];
                if (score && score[achievemensInfo[id]["id"]]){
                  ranks[j]['score']=score[achievemensInfo[id]["id"]]
                }
                if (certificateInfo[id]) {
                  const {certificateNum, certificateDate, validityStart,certificateUrl} = certificateInfo[id];
                  ranks[j].certificateNum = certificateNum;
                  ranks[j].certificateDate = certificateDate;
                  ranks[j].validityStart = validityStart;
                  if (certificateUrl) ranks[j].certificateUrl = certificateUrl;
                }
                if (achievemensInfo[id]) {
                  const {classAddress, classEnd, classStart, lecturerName, achievementRemark} = achievemensInfo[id];
                  ranks[j].classAddress = classAddress;
                  ranks[j].classEnd = classEnd;
                  ranks[j].classStart = classStart;
                  ranks[j].achievementRemark = achievementRemark;
                  ranks[j].lecturerName = lecturerName;
                }
              }
               //对培训历程按照结束时间排序
               this.rankData.ranks.sort((pre, next) => {
                 const next_year = new Date(next.classEnd).getTime();
                 const pre_year = new Date(pre.classEnd).getTime();
                 return next_year - pre_year ;
              });
            }
            this.showInfo = true;
          })
          .catch((err)=>{
            console.error(err);
          });
      },
      getAge(d) {
        return this.$yioks.jsGetAge(d);
      }
    },
    filters:{
      coachHistoryFilter,
      level(level){
        if (!level){
          return '--'
        }
        return LevelFilters(level)
      },
    }
  }
</script>

<style lang="stylus" scoped>
  @import "~@/assets/css/variable";
  @import "~@/assets/css/mixin";
  .scoreNav, .scoreMain {
    flex: 1 1 auto;
    height: 100%;
  }
  .scoreNav {
    display: flex;
    align-items: center;
    color: $color_white;
    font-size: $font_size_big;
    line-height: $font_size_big;
  }
  .scoreMain {
    width: 100%;
    padding: 25px 0 25px 25px;
    background-color: $block_bg_color_base;
    .scrollArea {
      width: 100%;
      height: 100%;
      .enquiriesResult {
        padding-right: 30px;
        .stuInfo {
          display: flex;
          font-size: $font_size_big;
          border: 1px solid $color_white;
          .left {
            width: 77%;
            .tr {
              height: 60px;
              display: flex;
              border-bottom: 1px solid $color_white;
              .info_left {
                width: 48%;
                border-right: 1px solid #fff;
              }
              .td {
                padding: 0 0 0 20px;
                display: flex;
                align-items: center;
              }
            }
            .tr:last-child {
              border-bottom: none;
            }
          }
          .right {
            width: 23%;
            padding: 20px 0;
            display: flex;
            flex-direction: column;
            justify-content: space-around;
            align-items: center
            border-left: 1px solid $color_white;
            img {
              width: 120px;
              height: 120px;
              border-radius: 50%;
            }
          }
        }

        .rankInfoData {
          margin: 20px 0 20px 0;
          display: flex;
          justify-content: space-between;
          font-size: 20px;
          user-select: none;
          .title {
            display: flex;
            align-items: flex-end;
            .logo {
              margin: 0 10px 0 0;
            }
            p {
              line-height: 20px;
              span {
                margin: 0 0 0 10px;
                font-size: $font_size_medium;
              }
            }
          }
        }
        .rankInfo {
          position: relative;
          margin-bottom: 40px;
          border: 1px solid $color_white;
          .score-row {
            border-bottom: 1px solid $color_white;
            .score-table {
              .row {
                border-bottom: 1px solid $color_white;
                display:flex;
                &:last-child {
                  border-bottom: none;
                }
                .score-col {
                  text-align: center;
                  border-left: 1px solid $color_white;
                  flex:auto;
                  &:first-child {
                    border-left: none;
                  }
                  p {
                    margin: 10px;
                    font-size: $font_size_medium;
                    word-break: break-all;
                    &.score-note {
                      text-align: left;
                    }
                  }
                }
              }
            }
            &:last-child {
              border-bottom: none;
            }
            .score-col {
              text-align: center;
              border-left: 1px solid $color_white;
              &:first-child {
                border-left: none;
              }
              p {
                margin: 10px;
                font-size: $font_size_medium;
                word-break: break-all;
                &.score-note {
                  text-align: left;
                }
              }
            }
          }
          .bz{
            .score-col{
              text-align left
            }
          }
          .dashed-line {
            width: 100%;
            position: absolute;
            bottom: -22px;
            left: 0;
            border: 1px dashed $color_white;
          }
        }
        .LicenseInfo{
          margin-bottom 0
        }
        .tips-wrap {
          height: 400px;
          .stuInfoError {
            height: calc(100% - 40px);
            display: flex;
            .logo {
              padding: 0 30px 0 85px;
              font-size: 40px;
              color: $color_suc;
            }
            .tips {
              padding: 15px 0 0;
              p {
                font-size: $font_size_big;
                margin: 10px 0;
              }
              p:first-child {
                margin: 0 0 20px 0;
                font-size: 20px;
              }
            }
          }
          .btn-wrap {
            display: flex;
            justify-content: center;
            .btn {
              margin: 0 20px;
              padding: 8px 12px;
              border-radius: 3px;
              font-size: $font_size_medium;
              background-color: $color_suc;
              border: none;
              outline: none;
              cursor: pointer;
            }
          }
        }
      }
    }
  }
</style>
